

























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { DocumentVersionModel, DocumentVersionType, DocumentPageModel, EVENT_BUS } from '@/types';
import { DocumentVersionService } from '@/services/DocumentVersionService';
import { BTableHelpers, ModalHelpers } from '@/mixins';
import { EventBus } from '@/classes/EventBus';

export default Vue.extend({
  name: 'MStoreVersionsTab',
  mixins: [BTableHelpers, ModalHelpers],
  props: {
    IsLockAcquired: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      documentVersions: [] as DocumentVersionModel[],
      fields: [
        {
          number: {
            label: 'Version Number',
            sortable: true
          }
        },
        {
          type: {
            label: 'Version Type',
            sortable: true,
            formatter: (value: any) => {
              return DocumentVersionType[value];
            }
          }
        },
        {
          'documentType.description': {
            label: 'Document Type',
            sortable: true
          }
        },
        {
          'user.name': {
            label: 'User',
            sortable: true
          }
        },
        {
          date: {
            label: 'Created Date/Time',
            sortable: true,
            formatter: 'date'
          }
        },
        {
          details: {
            label: 'Details',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    ...mapActions('documentViewStore', ['setDocumentVersionBeingViewed', 'loadPage', 'setDocumentSearchModel']),
    setDocumentVersion(this: any, version: DocumentVersionModel) {
      this.setDocumentVersionBeingViewed(version);
      this.loadPage(1);
      EventBus.$emit(EVENT_BUS.DOCUMENT_VERSION_CHANGED, {
        documentId: version.documentId,
        cabinetId: version.cabinet.id
      });
    },
    async getDocumentVersions(this: any) {
      this.isLoading = true;
      this.documentVersions = await DocumentVersionService.getDocumentVersionsAsync(this.documentSearchModel.cabinetId, this.documentSearchModel.documentId).catch((reason: any) => {
        this.isLoading = false;
      });
      this.isLoading = false;
    },
    async onMakeCurrentVersion(this: any, version: DocumentVersionModel) {
      const confirmed = await this.showConfirmationModalAsync(this.$bvModal, 'You are about to change the current version. The new document will be loaded when this has been completed.');
      if (!confirmed) {
        return;
      }
      this.isLoading = true;
      try {
        const documentSearchModel = await DocumentVersionService.makeCurrentVersionAsync(version.currentVersionDocumentId, version.id);
        this.setDocumentSearchModel(documentSearchModel);
        this.loadPage(1);
        await this.getDocumentVersions();
        EventBus.$emit(EVENT_BUS.DOCUMENT_VERSION_CHANGED, {
          documentId: version.documentId,
          cabinetId: version.cabinet.id
        });
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    isViewButtonDisabled(this: any, row: DocumentVersionModel) {
      const currentlyViewedDocumentId: number = this.versionBeingViewed.documentId ? this.versionBeingViewed.documentId : this.documentSearchModel.documentId;
      return row.documentId === currentlyViewedDocumentId;
    },
    rowColor(row: DocumentVersionModel) {
      return row.documentId === row.currentVersionDocumentId ? 'table-success' : '';
    }
  },
  computed: {
    ...mapGetters('documentViewStore', ['documentSearchModel', 'versionBeingViewed', 'deletedPage'])
  },
  watch: {
    async deletedPage(this: any, value: DocumentPageModel) {
      if (value.documentId === this.documentSearchModel.documentId) {
        await this.getDocumentVersions();
      }
    }
  },
  async mounted(this: any) {
    await this.getDocumentVersions();
  },
  components: {
    LoadingSpinner
  }
});
